import i18n from '@/plugins/i18n';

const applicationGraphs = () => ({
  lineCharts: [
    {
      width: '18%',
      widthInPer: '100%',
      title: i18n.global.t('serviceApdex'),
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_apdex',
      queryMetricType: 'readMetricsValue',
      chartType: 'ChartGauge',
      enabled: false,
      aggregation: '/',
      aggregationNum: '10000',
      colorEncoder: true,
      good: ['0.84', '1.00'],
      fair: ['0.69', '0.83'],
      poor: ['0.00', '0.68'],
      formatValue: (val) => val / 100,
      showApdexInfo: true,
    },
    {
      width: '38.5%',
      title: i18n.global.t('apm.service-instance-load'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      sortOrder: 'DES',
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_pv',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [
        /* Removing Child Queries */
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_instance_cpm',
        //   queryMetricType: 'readMetricsTotalValue',
        //   name: 'total',
        // },
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_instance_cpm',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'pm',
        // },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '38.5%',
      title: i18n.global.t('bm.service-load'),
      header: {
        title: i18n.global.t('loadTimeTitle'),
        titleIcon: '',
        content: [],
        displayOnlyUnit: true,
        displayCustomButton: false,
        customButtonProp: {
          title: i18n.global.t('bm.slow-traces'),
        },
      },
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_resp_time',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'browser_app_apdex',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'apdex'
        // }
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_cpm',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'pm',
        // },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('ms-average'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      title: i18n.global.t('errorTitle'),
      header: {
        title: i18n.global.t('errorTitle'),
        titleIcon: 'error',
        content: [],
        isError: true,
        hidePercentageParam: true,
        displayCustomButton: false,
        customButtonProp: {
          title: i18n.global.t('apm.error-traces'),
        },
      },
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_app_error_sum',
      queryMetricType: 'readCustomMetricsValues',
      childQueries: [
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'database_access_percentile',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'percentage',
        // },
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'database_access_epm',
        //   queryMetricType: 'readMetricsTotalValue',
        //   name: 'total',
        // },
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'database_access_epm',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'pm',
        // },
      ],
      chartType: 'ApexChartLine',
      unit: 'No',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
  barCharts: [
    {
      width: '48%',
      title: i18n.global.t('bm.user-impacted-by-errors'),
      header: {
        title: i18n.global.t('bm.user-impacted-by-errors'),
        titleIcon: 'error',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
        hideCustomToolbarButtons: true,
      },
      chartColor: ['#008FFB'],
      height: '25em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'browser_user_impacted',
      queryMetricType: 'readCustomMetricsValues',

      chartType: 'ApexChartBar',
      // unit: 'CPM - calls per minute',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('number-of-users'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
  heatMaps: [
    {
      // width: '48%',
      width: '97.7%',
      language: 'JAVA',
      icon: 'error',
      title: i18n.global.t('bm.error-count-map'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '47.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      // metricName: 'browser_app_pv',
      metricName: 'browser_app_resp_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_instance_cpm',
        //   queryMetricType: 'readMetricsTotalValue',
        //   name: 'total',
        // },
        // {
        //   entityType: 'Service',
        //   independentSelector: false,
        //   metricType: 'REGULAR_VALUE',
        //   metricName: 'service_instance_cpm',
        //   queryMetricType: 'readMetricsValue',
        //   name: 'pm',
        // },
      ],
      chartType: 'ApexChartBar',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
});
export default applicationGraphs;
